import Cookies from 'js-cookie'

export function getCookie(key) {
    let value = Cookies.get(key);
    if (value == undefined) {
        return "";
    }
    return value;
}

export function setCookie(key, value) {
    return Cookies.set(key, value)
}

export function removeCookie(key) {
    return Cookies.remove(key)
}


// WEBPACK FOOTER //
// ./src/other/utils/cookie.js